import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";
import EpcsAuthorizationBanner from "./EpcsAuthorizationBanner";

registerExtension("site.layout.header.below", EpcsAuthorizationBanner, "EpcsAuthorizationBanner");
